export const WIDGET_FRAME_CONTENT_CLASS = "widget-frame-content";
